import { api } from "@/lib/orgApi";

export function getPatientSmsConsent(patientId) {
  return api.get(`/patients/${encodeURIComponent(patientId)}/sms-consent`).then((r) => r.data);
}

export function recordPatientSmsConsent(patientId, { action, patientAuthorized = false } = {}) {
  return api
    .post(`/patients/${encodeURIComponent(patientId)}/sms-consent`, {
      action,
      patientAuthorized: action === "grant" ? Boolean(patientAuthorized) : false,
    })
    .then((r) => r.data);
}
